module.exports = __webpack_public_path__ + "img/pg4-article-title2-inner.8b89b26c.png";